"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useThemeEval = void 0;
var use_theme_1 = require("./use-theme");
var useThemeEval = function () {
  var t = (0, use_theme_1.useTheme)();
  return function (func) {
    return func({
      theme: t
    });
  };
};
exports.useThemeEval = useThemeEval;